import { Gateway, User } from "@impulse/sdp-shared-models";

export type SessionStatus = "all" | "active" | "inactive";

export namespace DeviceType {
	export const Type = {
		windows: "Windows",
		mac: "macOS",
		iOS: "iOS",
		android: "Android",
		linux: "Linux"
	};
	export type BackingType = keyof typeof Type;
}

export interface DeviceInterface {
	ipv4?: string;
	ipv6?: string;
	mac?: string;
	name: string;
	display: boolean;
}

export namespace Session {
	export type SessionUuid = string;
	export type UserName = User.Name;
	export type UserType = "cognito" | "saml";
}

export interface Session {
	sessionUuid: Session.SessionUuid;
	accountName: string;
	userName: Session.UserName;
	// TODO once all session data is the new version userType is no longer optional
	userType?: Session.UserType;
	startTime: number;
	endTime?: number;
	deviceUuid?: string;
	deviceName: string;
	type: DeviceType.BackingType;
	interfaces?: DeviceInterface[];
	clientVersion?: string;
	gatewayType: Gateway.Type;
	gatewayUuid?: string;
}

export interface SessionViewPartial {
	gatewayName: string;
	isPrimaryUser: boolean;
}

export type SessionView = Session & SessionViewPartial;

export namespace DisconnectSessions {
	export type SessionUuid = Session.SessionUuid;
	export type UserName = Session.UserName;
	export type UserType = Session.UserType;

	export interface SessionRequest {
		sessionUuid: Session.SessionUuid;
	}

	export interface UserRequest {
		userName: Session.UserName;
		userType?: Session.UserType;
	}

	export type Request = DisconnectSessions.SessionRequest | DisconnectSessions.UserRequest;

	export interface Response {
		sessionUuids: Session.SessionUuid[];
	}

}
